import React, { memo } from "react";

import { classNames } from "helpers";

import { getSelectedPictureUrls, getVehicleImage } from "../helpers";
import { AdImageProps } from "../types";

/** Naslovna slika oglasa: prva odabrana fotografija, a bez nje slika vozila. */
const AdImage: React.FC<AdImageProps> = ({ formValues, className }) => {
  const [cover] = getSelectedPictureUrls(formValues);

  return (
    <div className={classNames("relative overflow-hidden", cover ? "bg-slate-100" : "bg-gradient-to-br from-blue-50 to-blue-100", className)}>
      {cover ? (
        <img src={cover} alt="" className="absolute inset-0 w-full h-full object-cover" />
      ) : (
        // Slika vozila ima širok prozirni rub, pa se uvećava unutar okvira da auto ispuni karticu.
        <img src={getVehicleImage(formValues)} alt="" className="w-full h-full object-contain scale-[1.4]" />
      )}
    </div>
  );
};

export default memo(AdImage);
